import { Backdrop, CircularProgress } from '@mui/material';
import { createContext, useState, type FC, type ReactNode } from 'react';

type BackdropContextType = {
  backdropOpen: boolean;
  handleBackdropOpen: () => void;
  handleBackdropClose: () => void;
};

export const BackdropContext = createContext<BackdropContextType>({
  backdropOpen: false,
  handleBackdropOpen: () => {},
  handleBackdropClose: () => {},
});

export const BackdropContextProvider: FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [backdropOpen, setBackdropOpen] = useState(false);
  const handleBackdropOpen = () => {
    setBackdropOpen(true);
  };
  const handleBackdropClose = () => {
    setBackdropOpen(false);
  };

  return (
    <BackdropContext.Provider
      value={{
        backdropOpen,
        handleBackdropOpen,
        handleBackdropClose,
      }}>
      <Backdrop
        open={backdropOpen}
        sx={(theme) => ({
          color: '#fff',
          zIndex: theme.zIndex.drawer + 10000000,
        })}>
        <CircularProgress />
      </Backdrop>
      {children}
    </BackdropContext.Provider>
  );
};
